import React, {useMemo} from "react";
import moment from "moment";
import "moment-duration-format";
import {Trans, useTranslation} from "react-i18next";
import {deliveryStatusEnum, deliveryStatuses} from "../../../../../constants/constants";
import {useStore} from "@vigo/hooks";
import {TrialTitle} from "./OrderStepsStyles";
import {StepHeaderTypes} from "./StepTypes";
import {CourierLink} from "../../../../_defaultComponents/CourierLink/CourierLink";

const StepHeader = ({
    state,
    courierLinkTo,
    stepInfoName,
    cardType,
    assignedCourier,
    activeLink,
    deliveryType,
    _id,
    routes,
    orderNumber,
    trial,
    isTrial,
    isReceiptNumber
}: StepHeaderTypes) => {
    const stores = useStore();
    const {t} = useTranslation(["orderDetail"]);
    const deliveryStatusList = useMemo(() => deliveryStatuses.map(i => i.value), []);

    const pickupETAValues = () => {
        if (_id == null) return "";
        const route = routes?.find(r => r.pickupInfoId === _id);
        const duration = moment.duration(route?.timeInSeconds, "seconds");
        const formatted = duration.format("mm:ss", {trim: false});
        return t("customerPickupEtaFormat", {ns: "orderDetail", formatted});
    };

    const orderETAValues = () => {
        if (!orderNumber) return "";
        const route = routes?.find(r => r.orderNumber === orderNumber);
        const duration = moment.duration(route?.timeInSeconds, "seconds");
        const formatted = duration.format("mm:ss", {trim: false});
        return t("customerDeliveredEtaFormat", {ns: "orderDetail", formatted});
    };

    const renderEtaText = () => {
        if (state === deliveryStatusEnum.ON_THE_WAY_FOR_PICK_UP) {
            return pickupETAValues();
        } else if (state === deliveryStatusEnum.ON_DELIVERY) {
            return orderETAValues();
        }
        return "";
    };

    const renderContent = () => {
        const _deliveryType = deliveryType === "productReturn" ? "productReturn" : "delivery";
        const i18Prefix = `stepInfo.${_deliveryType}`;
        if (isTrial) {
            const productNames = trial.products?.map(product => product.productName)?.join(",");
            return (
                <TrialTitle iscompleted={Boolean(trial.endDate).toString()}>
                    {t(`${i18Prefix}.trial`, {ns: "orderDetail", products: productNames})}
                </TrialTitle>
            );
        } else if (state === "waiting") {
            const i18Suffix = _deliveryType === "productReturn" ? "waitingReturn" : "waiting";
            return <>{t(`${i18Prefix}.${i18Suffix}`, {ns: "orderDetail"})}</>;
        } else if (deliveryStatusList.includes(state)) {
            let i18nKey = `${i18Prefix}.${state}`;
            if (state === "onTheWayForTransfer")
                i18nKey += cardType === "newOrder" ? ".newOrder" : ".default";

            if (isReceiptNumber && (state === "onDelivery" || state === "onDeliveryAddress")) {
                i18nKey += "ReceiptNumber";
            }

            const assignedCourierName = (
                <CourierLink to={courierLinkTo} activelink={activeLink.toString()} />
            );
            return (
                <>
                    <Trans
                        i18nKey={i18nKey}
                        t={t}
                        ns="orderDetail"
                        components={{courierLink: assignedCourierName}}
                        values={{stepInfoName, courierName: assignedCourier}}
                    />
                    <br />
                    {renderEtaText()}
                </>
            );
        } else {
            const i18Suffix = _deliveryType === "productReturn" ? "returnNotFound" : "waiting";
            return <>{t(`${i18Prefix}.${i18Suffix}`, {ns: "orderDetail"})}</>;
        }
    };

    return <>{renderContent()}</>;
};

export default StepHeader;
